export const CampaignStatusIcons = {
  Active: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{
        borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <path
        id="check_circle_20dp_5F6368_FILL0_wght400_GRAD0_opsz20_1_"
        data-name="check_circle_20dp_5F6368_FILL0_wght400_GRAD0_opsz20 (1)"
        d="M103.8-851.625l5.578-5.555-1.2-1.2-4.383,4.359-1.992-1.969-1.2,1.2ZM105-846a8.771,8.771,0,0,1-3.492-.7,9.071,9.071,0,0,1-2.871-1.934,9.071,9.071,0,0,1-1.934-2.871A8.771,8.771,0,0,1,96-855a8.746,8.746,0,0,1,.7-3.5,9.109,9.109,0,0,1,1.934-2.859,9.072,9.072,0,0,1,2.871-1.934A8.771,8.771,0,0,1,105-864a8.746,8.746,0,0,1,3.5.7,9.109,9.109,0,0,1,2.859,1.934A9.109,9.109,0,0,1,113.3-858.5a8.746,8.746,0,0,1,.7,3.5,8.771,8.771,0,0,1-.7,3.492,9.071,9.071,0,0,1-1.934,2.871A9.108,9.108,0,0,1,108.5-846.7,8.746,8.746,0,0,1,105-846Zm0-1.687a7.052,7.052,0,0,0,5.18-2.133,7.052,7.052,0,0,0,2.133-5.18,7.052,7.052,0,0,0-2.133-5.18,7.052,7.052,0,0,0-5.18-2.133,7.052,7.052,0,0,0-5.18,2.133A7.052,7.052,0,0,0,97.688-855a7.052,7.052,0,0,0,2.133,5.18A7.052,7.052,0,0,0,105-847.687ZM105-855Z"
        transform="translate(-96 864)"
        fill="currentColor"
      />
    </svg>
  ),
  Archived: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{
        //   borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <path
        id="archive_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M153-801.536l3.857-3.857-1.366-1.366-1.527,1.527v-4.018h-1.929v4.018l-1.527-1.527-1.366,1.366Zm-7.071-9.321v10.929h14.143v-10.929Zm0,12.857a1.857,1.857,0,0,1-1.362-.567,1.857,1.857,0,0,1-.567-1.362v-12.7a1.914,1.914,0,0,1,.141-.723,2.029,2.029,0,0,1,.422-.643l1.446-1.446a1.849,1.849,0,0,1,.641-.429,1.993,1.993,0,0,1,.725-.134h11.25a1.993,1.993,0,0,1,.725.134,1.849,1.849,0,0,1,.641.429l1.446,1.446a2.029,2.029,0,0,1,.422.643,1.914,1.914,0,0,1,.141.723v12.7a1.857,1.857,0,0,1-.567,1.362,1.857,1.857,0,0,1-1.362.567Zm.161-14.786h13.821l-1.286-1.286h-11.25ZM153-805.393Z"
        transform="translate(-144 816)"
        fill="currentColor"
      />
    </svg>
  ),
  Cancelled: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{
        // borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <path
        id="disabled_by_default_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M149.518-802.152l3.487-3.487,3.487,3.487,1.356-1.356-3.487-3.487,3.487-3.487-1.366-1.366-3.487,3.487-3.487-3.487-1.356,1.356,3.487,3.487-3.487,3.487ZM145.929-798a1.857,1.857,0,0,1-1.362-.567,1.857,1.857,0,0,1-.567-1.362v-14.143a1.857,1.857,0,0,1,.567-1.362,1.857,1.857,0,0,1,1.362-.567h14.143a1.857,1.857,0,0,1,1.362.567,1.857,1.857,0,0,1,.567,1.362v14.143a1.857,1.857,0,0,1-.567,1.362,1.857,1.857,0,0,1-1.362.567Zm0-1.929h14.143v-14.143H145.929Zm0-14.143v0Z"
        transform="translate(-144 816)"
        fill="currentColor"
      />
    </svg>
  ),
  Draft: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.875"
      height="18"
      viewBox="0 0 16.875 18"
      style={
        {
          // borderRadius: "50%",
          // boxShadow: "0 0 5px #d9e5ed",
        }
      }
    >
      <path
        id="edit_document_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M201-846v-2.648l4.922-4.9a1.032,1.032,0,0,1,.378-.251,1.183,1.183,0,0,1,.413-.077,1.146,1.146,0,0,1,.429.082,1.135,1.135,0,0,1,.373.246l1.031,1.055a1.308,1.308,0,0,1,.241.378,1.064,1.064,0,0,1,.087.413,1.238,1.238,0,0,1-.077.42,1,1,0,0,1-.251.382l-4.9,4.9Zm6.75-5.7L206.7-852.75Zm-5.625,4.57h1.055l2.7-2.7-.516-.539-.516-.516-2.719,2.7ZM193.688-846a1.622,1.622,0,0,1-1.2-.5,1.631,1.631,0,0,1-.492-1.192v-14.625a1.625,1.625,0,0,1,.5-1.192,1.625,1.625,0,0,1,1.192-.5H201l4.5,4.5v3.563h-1.687v-2.437h-3.937v-3.937h-6.187v14.625h5.625V-846ZM199.594-855Zm5.766,4.641-.516-.516,1.031,1.055Z"
        transform="translate(-192 864)"
        fill="currentColor"
      />
    </svg>
  ),
  Paused: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{
        borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <g
        id="Group_76646"
        data-name="Group 76646"
        transform="translate(22482 11692)"
      >
        <path
          id="check_circle_20dp_5F6368_FILL0_wght400_GRAD0_opsz20_1_"
          data-name="check_circle_20dp_5F6368_FILL0_wght400_GRAD0_opsz20 (1)"
          d="M105-846a8.771,8.771,0,0,1-3.492-.7,9.071,9.071,0,0,1-2.871-1.934,9.071,9.071,0,0,1-1.934-2.871A8.771,8.771,0,0,1,96-855a8.746,8.746,0,0,1,.7-3.5,9.109,9.109,0,0,1,1.934-2.859,9.072,9.072,0,0,1,2.871-1.934A8.771,8.771,0,0,1,105-864a8.746,8.746,0,0,1,3.5.7,9.109,9.109,0,0,1,2.859,1.934A9.109,9.109,0,0,1,113.3-858.5a8.746,8.746,0,0,1,.7,3.5,8.771,8.771,0,0,1-.7,3.492,9.071,9.071,0,0,1-1.934,2.871A9.108,9.108,0,0,1,108.5-846.7,8.746,8.746,0,0,1,105-846Zm0-1.687a7.052,7.052,0,0,0,5.18-2.133,7.052,7.052,0,0,0,2.133-5.18,7.052,7.052,0,0,0-2.133-5.18,7.052,7.052,0,0,0-5.18-2.133,7.052,7.052,0,0,0-5.18,2.133A7.052,7.052,0,0,0,97.688-855a7.052,7.052,0,0,0,2.133,5.18A7.052,7.052,0,0,0,105-847.687Z"
          transform="translate(-22578 -10828)"
          fill="currentColor"
        />
        <path
          id="motion_photos_paused_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M104.156-849.106h2.128V-856.2h-2.128Zm4.256,0h2.128V-856.2h-2.128ZM107.348-852.652Z"
          transform="translate(-22580.156 -10830.802)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  "Pending Deletion": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.984"
      height="18"
      viewBox="0 0 14.984 18"
      style={
        {
          // borderRadius: "50%",
          // boxShadow: "0 0 5px #d9e5ed",
        }
      }
    >
      <g
        id="Group_76648"
        data-name="Group 76648"
        transform="translate(22648.599 11534)"
      >
        <path
          id="auto_delete_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M195.1-812.9v0Zm3.595,14.276H195.1a1.793,1.793,0,0,1-1.315-.547,1.793,1.793,0,0,1-.547-1.315V-812.9H192v-1.862h4.966V-816h4.966v1.242H206.9v1.862h-1.241v3.853q-.466-.077-.931-.116a4.8,4.8,0,0,0-.931.013v-3.75H195.1v12.4h2.746a5.207,5.207,0,0,0,.345.966A7.788,7.788,0,0,0,198.7-798.621Zm-1.733-3.724h.621a5.675,5.675,0,0,1,.621-2.871l.621-1.06v-4.759h-1.862Zm3.1-5.276a9.392,9.392,0,0,1,.841-.582,5.923,5.923,0,0,1,1.022-.5v-2.328h-1.862Z"
          transform="translate(-22840.6 -10718)"
          fill="currentColor"
        />
        <g
          id="Group_76647"
          data-name="Group 76647"
          transform="translate(-22639.201 -11525.311)"
        >
          <path
            id="Path_25208"
            data-name="Path 25208"
            d="M6,2,6,4.793,7.862,6.655,6,8.522,6,11.31h5.586V8.517L9.724,6.655,11.586,4.8V2Zm4.655,6.75v1.629H6.931V8.75L8.793,6.888Z"
            transform="translate(-6 -2)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  ),
  Removed: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.428"
      height="18"
      viewBox="0 0 15.428 18"
      style={{
        // borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <path
        id="delete_forever_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M197.571-802.848l2.143-2.143,2.143,2.143,1.366-1.366-2.143-2.143,2.143-2.143-1.366-1.366-2.143,2.143-2.143-2.143-1.366,1.366,2.143,2.143-2.143,2.143ZM195.214-798a1.857,1.857,0,0,1-1.362-.566,1.857,1.857,0,0,1-.567-1.362v-12.857H192v-1.929h5.143V-816h5.143v1.286h5.143v1.929h-1.286v12.846a1.867,1.867,0,0,1-.567,1.378,1.864,1.864,0,0,1-1.362.563Zm9-14.786h-9v12.857h9Zm-9,0v0Z"
        transform="translate(-192 816)"
        fill="currentColor"
      />
    </svg>
  ),
  Running: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{
        borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <path
        id="play_circle_20dp_5F6368_FILL0_wght400_GRAD0_opsz20_1_"
        data-name="play_circle_20dp_5F6368_FILL0_wght400_GRAD0_opsz20 (1)"
        d="M102.75-851.062,108.938-855l-6.187-3.937ZM105.007-846a8.787,8.787,0,0,1-3.5-.7,9.071,9.071,0,0,1-2.871-1.934,9.074,9.074,0,0,1-1.934-2.87,8.8,8.8,0,0,1-.7-3.5,8.719,8.719,0,0,1,.7-3.493,9.108,9.108,0,0,1,1.934-2.859,9.074,9.074,0,0,1,2.87-1.934,8.8,8.8,0,0,1,3.5-.7,8.719,8.719,0,0,1,3.493.7,9.108,9.108,0,0,1,2.859,1.934A9.092,9.092,0,0,1,113.3-858.5a8.742,8.742,0,0,1,.7,3.492,8.787,8.787,0,0,1-.7,3.5,9.071,9.071,0,0,1-1.934,2.871A9.092,9.092,0,0,1,108.5-846.7,8.742,8.742,0,0,1,105.007-846ZM105-847.687a7.052,7.052,0,0,0,5.18-2.133,7.052,7.052,0,0,0,2.133-5.18,7.052,7.052,0,0,0-2.133-5.18,7.052,7.052,0,0,0-5.18-2.133,7.052,7.052,0,0,0-5.18,2.133A7.052,7.052,0,0,0,97.688-855a7.052,7.052,0,0,0,2.133,5.18A7.052,7.052,0,0,0,105-847.687ZM105-855Z"
        transform="translate(-96 864)"
        fill="currentColor"
      />
    </svg>
  ),
  Expired: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.854"
      height="18"
      viewBox="0 0 17.854 18"
      style={
        {
          // borderRadius: "50%",
          // boxShadow: "0 0 5px #d9e5ed",
        }
      }
    >
      <g
        id="Group_76650"
        data-name="Group 76650"
        transform="translate(22580.999 11455.78)"
      >
        <path
          id="more_time_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M103.971-893.8a7.713,7.713,0,0,1-3.107-.629,8.1,8.1,0,0,1-2.527-1.709,8.1,8.1,0,0,1-1.709-2.529A7.725,7.725,0,0,1,96-901.779a7.712,7.712,0,0,1,.629-3.107,8.1,8.1,0,0,1,1.709-2.527,8.1,8.1,0,0,1,2.528-1.708,7.719,7.719,0,0,1,3.107-.629q.285,0,.567.024t.572.071v1.732q-.261-.048-.558-.083a4.888,4.888,0,0,0-.581-.036,6.033,6.033,0,0,0-4.426,1.839,6.033,6.033,0,0,0-1.839,4.426,6.033,6.033,0,0,0,1.839,4.426,6.033,6.033,0,0,0,4.426,1.839,6.033,6.033,0,0,0,4.426-1.839,6.033,6.033,0,0,0,1.839-4.426,4.875,4.875,0,0,0-.036-.581q-.036-.3-.083-.558h1.732q.047.285.071.57t.024.57a7.719,7.719,0,0,1-.629,3.107,8.1,8.1,0,0,1-1.709,2.528,8.1,8.1,0,0,1-2.529,1.709A7.725,7.725,0,0,1,103.971-893.8Zm2.683-4.01-3.536-3.536v-4.983h1.709v4.271l3.037,3.037Z"
          transform="translate(-22677 -10543.976)"
          fill="currentColor"
        />
        <path
          id="work_alert_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M124.69-833.473a.441.441,0,0,0,.322-.138.441.441,0,0,0,.138-.322.441.441,0,0,0-.138-.322.441.441,0,0,0-.322-.138.441.441,0,0,0-.322.138.441.441,0,0,0-.138.322.441.441,0,0,0,.138.322A.441.441,0,0,0,124.69-833.473Zm-.459-1.837h.919v-1.837h-.919Zm.455,3.675a3.531,3.531,0,0,1-2.6-1.076,3.553,3.553,0,0,1-1.072-2.6,3.531,3.531,0,0,1,1.076-2.6,3.553,3.553,0,0,1,2.6-1.072,3.531,3.531,0,0,1,2.6,1.076,3.553,3.553,0,0,1,1.072,2.6,3.531,3.531,0,0,1-1.076,2.6A3.553,3.553,0,0,1,124.685-831.636Z"
          transform="translate(-22691.512 -10616.794)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  Exhausted: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.5"
      height="18"
      viewBox="0 0 13.5 18"
      style={
        {
          // borderRadius: "50%",
          // boxShadow: "0 0 5px #d9e5ed",
        }
      }
    >
      <path
        id="battery_error_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M289.132-846a1.1,1.1,0,0,1-.806-.323,1.085,1.085,0,0,1-.326-.8v-14.062a1.089,1.089,0,0,1,.323-.8,1.089,1.089,0,0,1,.8-.323h1.688V-864h3.375v1.688h1.688a1.089,1.089,0,0,1,.8.323,1.089,1.089,0,0,1,.323.8v6.469a6.826,6.826,0,0,0-.889.431,5,5,0,0,0-.8.577v-6.914h-5.625v12.938h4.477a6.079,6.079,0,0,0,.586.914,5.007,5.007,0,0,0,.75.773ZM289.688-847.687Zm7.383.563-1.2-1.2,1.617-1.617-1.617-1.617,1.2-1.2,1.617,1.617,1.617-1.617,1.2,1.2-1.617,1.617,1.617,1.617-1.2,1.2-1.617-1.617Z"
        transform="translate(-288 864)"
        fill="currentColor"
      />
    </svg>
  ),
  Deleted: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.428"
      height="18"
      viewBox="0 0 15.428 18"
      style={{
        // borderRadius: "50%",
        boxShadow: "0 0 5px #d9e5ed",
      }}
    >
      <path
        id="delete_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M195.214-798a1.857,1.857,0,0,1-1.362-.567,1.857,1.857,0,0,1-.567-1.362v-12.857H192v-1.929h5.143V-816h5.143v1.286h5.143v1.929h-1.286v12.846a1.867,1.867,0,0,1-.566,1.378,1.864,1.864,0,0,1-1.362.563Zm9-14.786h-9v12.857h9Zm-7.071,10.929h1.929v-9h-1.929Zm3.214,0h1.929v-9h-1.929Zm-5.143-10.929v0Z"
        transform="translate(-192 816)"
        fill="currentColor"
      />
    </svg>
  ),
  Unknown: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.875"
      height="18"
      viewBox="0 0 16.875 18"
      style={
        {
          // borderRadius: "50%",
          // boxShadow: "0 0 5px #d9e5ed",
        }
      }
    >
      <path
        id="unknown_document_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
        d="M145.688-862.312v0Zm1.688,9.563h3.234a7.784,7.784,0,0,1,.422-.891,4.6,4.6,0,0,1,.563-.8h-4.219Zm0,3.375h2.906a7.737,7.737,0,0,1-.094-.844,5.077,5.077,0,0,1,.023-.844h-2.836ZM145.688-846a1.625,1.625,0,0,1-1.192-.5,1.625,1.625,0,0,1-.5-1.192v-14.625a1.625,1.625,0,0,1,.5-1.192,1.625,1.625,0,0,1,1.192-.5H153l4.5,4.5v2.906a7.756,7.756,0,0,0-.844-.094,5.077,5.077,0,0,0-.844.023v-1.711h-3.938v-3.937h-6.188v14.625h5.18a8.592,8.592,0,0,0,.563.891,5.584,5.584,0,0,0,.7.8Zm10.693-9a4.324,4.324,0,0,1,3.182,1.318,4.351,4.351,0,0,1,1.313,3.188,4.325,4.325,0,0,1-1.318,3.182A4.35,4.35,0,0,1,156.37-846a4.324,4.324,0,0,1-3.182-1.318,4.351,4.351,0,0,1-1.312-3.188,4.324,4.324,0,0,1,1.318-3.182A4.351,4.351,0,0,1,156.38-855Zm-.005,6.75a.453.453,0,0,0,.334-.135.453.453,0,0,0,.135-.334.453.453,0,0,0-.135-.333.453.453,0,0,0-.334-.135.453.453,0,0,0-.333.135.453.453,0,0,0-.135.333.453.453,0,0,0,.135.334A.453.453,0,0,0,156.375-848.25Zm-.328-1.43h.68v-.141a.8.8,0,0,1,.082-.4,1.3,1.3,0,0,1,.27-.3,2.315,2.315,0,0,0,.445-.527,1,1,0,0,0,.141-.5,1.193,1.193,0,0,0-.328-.844,1.251,1.251,0,0,0-.961-.352,1.317,1.317,0,0,0-.794.258,1.489,1.489,0,0,0-.518.68l.633.258a.712.712,0,0,1,.229-.4.649.649,0,0,1,.451-.164.655.655,0,0,1,.434.146.539.539,0,0,1,.176.44.5.5,0,0,1-.094.281,1.615,1.615,0,0,1-.281.3,3.144,3.144,0,0,0-.281.27,1.577,1.577,0,0,0-.188.246,1.188,1.188,0,0,0-.07.219,2.369,2.369,0,0,0-.023.414Z"
        transform="translate(-144 864)"
        fill="currentColor"
      />
    </svg>
  ),
};

export const getCampaignStatusIcons = (status = null) => {
  switch (status) {
    case "Active":
      return CampaignStatusIcons?.[status];
    case "Archived":
      return CampaignStatusIcons?.[status];
    case "Cancelled":
      return CampaignStatusIcons?.[status];
    case "Draft":
      return CampaignStatusIcons?.[status];
    case "Paused":
      return CampaignStatusIcons?.[status];
    case "Pending Deletion":
      return CampaignStatusIcons?.[status];
    case "Removed":
      return CampaignStatusIcons?.[status];
    case "Running":
      return CampaignStatusIcons?.[status];
    case "Expired":
      return CampaignStatusIcons?.[status];
    case "Exhausted":
      return CampaignStatusIcons?.[status];
    case "Deleted":
      return CampaignStatusIcons?.[status];
    case "Unknown":
      return CampaignStatusIcons?.[status];
    default:
      return "";
  }
};
